var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 2.63,
    r: 2.63,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.3253,
    cy: 8.66125,
    r: 2.63,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3546,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.3253,
    cy: 40.3224,
    r: 2.63,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 46.3531,
    r: 2.63,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.66125,
    cy: 40.3224,
    r: 2.63,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.90539,
    cy: 8.66125,
    r: 2.63,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2159,
    cy: 13.9381,
    r: 2.63,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2159,
    cy: 19.214,
    r: 2.63,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9347,
    cy: 19.214,
    r: 2.63,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0441,
    cy: 19.214,
    r: 2.63,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9347,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0441,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9347,
    cy: 29.7687,
    r: 2.63,
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0441,
    cy: 29.7687,
    r: 2.63,
    fill: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2159,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2159,
    cy: 29.7687,
    r: 2.63,
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2159,
    cy: 35.046,
    r: 2.63,
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 13.9381,
    r: 2.63,
    fill: "black"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 19.214,
    r: 2.63,
    fill: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 29.7687,
    r: 2.63,
    fill: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4894,
    cy: 35.046,
    r: 2.63,
    fill: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7706,
    cy: 13.9381,
    r: 2.63,
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7706,
    cy: 19.214,
    r: 2.63,
    fill: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7706,
    cy: 24.4913,
    r: 2.63,
    fill: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7706,
    cy: 29.7687,
    r: 2.63,
    fill: "black"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7706,
    cy: 35.046,
    r: 2.63,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.b59aae990320c3a210f6a8f9e40cc88e.svg";
export { ForwardRef as ReactComponent };